@if (canPrint()) {
<div class="flex flex-justify-between flex-middle">
    <p class="flex-grow h3 s1-s s1-m">{{title | translate}}</p>
    <button class="_navigation-button"
            [ngClass]="'prev-' + uid"
            aria-label="Previous slide"
            type="button">
        <i class="icon-chevron-left _icon"
           aria-hidden="true"></i>
    </button>
    <button class="_navigation-button m-l-2 m-r-4-s m-r-4-m"
            [ngClass]="'next-' + uid"
            aria-label="Next slide"
            type="button">
        <i class="icon-chevron-right _icon"
           aria-hidden="true"></i>
    </button>
</div>
<carousel class="_carousel w-12 m-t"
          [slidesPerView]="'auto'"
          [scrollbar]="{ draggable: true }"
          [freeMode]="true"
          [style.--pc-slides-ceil]="pcSlidesCeil"
          [style.--pc-slides]="pcSlides"
          [style.--pc-gutter]="pcGutter"
          [navigation]="{
                    addIcons:false,
                    nextEl: '.next-' + uid,
                    prevEl: '.prev-' + uid,
                }"
          imageViewRoot
          [gtmList]="{listName : 'Product view related products carousel', listId : 'product_view_related_products'}">
    @if (listing) {
    @for (model of listing.models; track model) {
    <ng-template carouselSlide>
        <product [model]="model"
                 [gtmItem]="{position: $index+1, product : model}"></product>
    </ng-template>
    }
    }
</carousel>
}